export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.8e8b0e50.eot";